module.exports = __webpack_public_path__ + "static/media/visa.e85c7432.svg";